import { HttpError } from '../../services/api';
import { getApiUrl } from '../../config/env';

const INVALID_CREDENTIALS =
  'The email or password you entered is incorrect. Please try again.';

/** Map API/login failures to user-facing copy (401, 400, and common message shapes). */
export function resolveLoginError(error: unknown): string {
  if (error instanceof HttpError) {
    if (error.status === 401 || error.status === 400) {
      return INVALID_CREDENTIALS;
    }
    if (error.status === 403 && /verify|verification|unverified/i.test(error.message)) {
      return error.message;
    }
  }

  const message = error instanceof Error ? error.message : 'Login failed';
  const lower = message.toLowerCase();

  if (
    /invalid.*(email|password|credential)|incorrect.*(email|password)|wrong.*password|authentication failed|unauthorized/i.test(
      lower
    )
  ) {
    return INVALID_CREDENTIALS;
  }

  if (/verify your email|email.*not.*verified|unverified/i.test(lower)) {
    return message;
  }

  if (/timeout|timed out/i.test(lower)) {
    return 'Login request timed out. Please check your connection and try again.';
  }

  if (/network error|failed to fetch|econnrefused|err_network|fetch/i.test(lower)) {
    return `Cannot reach the API at ${getApiUrl()}. Start your backend or set REACT_APP_API_URL in .env.`;
  }

  if (error instanceof HttpError && error.status === 403) {
    return message;
  }

  return message || INVALID_CREDENTIALS;
}

export function isEmailVerificationRequired(error: unknown): boolean {
  if (error instanceof HttpError && error.status === 403) {
    return /verify|verification|unverified/i.test(error.message);
  }
  const message = error instanceof Error ? error.message : '';
  return /verify your email|email.*not.*verified|unverified/i.test(message.toLowerCase());
}
